module.exports = __webpack_public_path__ + "static/media/zm.e9281a2c.svg";